import React from "react";
import styled from "@emotion/styled";

interface BorderLessInputPropType {
  color: string;
  fullWidth?: boolean;
  placeHolder: string;
  setValue?: (value: string) => void;
  value: string;
}

const StyledInput = styled.input`
  background-color: transparent;
  border: none;
  color: var(--color) !important;
  font-size: 16px;
  font-family: "Poppins";
  height: 30px;
  outline: none !important;
  border-bottom: none !important;
  -webkit-text-fill-color: var(--color) !important;

  ::placeholder {
    color: var(--color) !important;
    opacity: 1;
  }
`;

export const PlaceholderLabelSpacing = styled.div`
  margin-bottom: 2px;
`;

export const PlaceholderBoxSpacing = styled.div`
  padding: 5px;
`;

export const PlaceholderParentContainer = styled.div`
  position: relative;
`;

export const PlaceholderChildContainer = styled.div`
  position: absolute;
  top: 0%;
  left: 10px;
  width: 95%;
`;

export default function BorderLessInput({
  color,
  placeHolder,
  value,
  setValue,
  fullWidth,
}: BorderLessInputPropType) {
  return (
    <StyledInput
      style={{ color: color, width: fullWidth ? "100%" : "250px" }}
      placeholder={placeHolder}
      value={value}
      onChange={(event) => {
        if (setValue) {
          setValue(event?.target.value);
        }
      }}
    />
  );
}
